import React from "react";
import type { ReactState } from "@/game/types/ReactTypes";
import type { HumanID, RoomID, Text } from "@/realize-shared/model/Types";
import type { Room, Rooms } from "./types/Game";
import type { UserIcon } from "../realize-shared/model/UserIcon";
import type { CreateRoomRequest, JoinRoomRequest } from "@/realize-shared/model/RequestTypes";
import type { ThemePack } from "./ShopItem";

type AppContext = {
    humanID: HumanID,
    room: Room | null,
}
& ReactState<"waiting", boolean>;

export const ReactAppContext = React.createContext<AppContext|null>(null);

export const useAppContext = () =>
{
    const context = React.useContext(ReactAppContext);

    AssertIsset(context, "useAppContext must be used within a ReactAppContext");

    return context;
};

export type FullAppContext = {
    joinRoom: (data: JoinRoomRequest | CreateRoomRequest) => Promise<void>;
    spectateRoom: (roomID: RoomID | false) => void;
    leaveRoom: (roomID: RoomID) => void;
    focusRoom: (roomID: RoomID | false) => void;
}
& AppContext
& ReactState<"username", Text | null>
& ReactState<"avatar", UserIcon | null>
& ReactState<"theme", ThemePack>
& ReactState<"room", Room | null>
& ReactState<"locked", boolean>
& ReactState<"rooms", Rooms>;

export const ReactFullAppContext = React.createContext<FullAppContext|null>(null);

export const useFullAppContext = () =>
{
    const context = React.useContext(ReactFullAppContext);

    AssertIsset(context, "useAppContext must be used within a ReactEditableAppContext");

    return context;
};
